import React, { useEffect, useMemo, useState } from 'react'
import {
  useAllTaskStatusMutation,
  useChangeTodosColorMutation,
  useChangeTodosStatusMutation,
  useDeleteTaskTodoMutation,
  useGetStatusByTodosQuery,
  useGetTotalTodosQuery,
  useRenameTaskTodoTitleMutation,
} from '../features/api/todoSlice'
import Todo from './Todo'

export const Footer = ({ filter, setFilter, setToggle, toggle }) => {
  const { data, isSuccess } = useGetStatusByTodosQuery(toggle)
  const { data: totalTask } = useGetTotalTodosQuery({ completed: false })
  const [changeTodosStatus, { isLoading }] = useChangeTodosStatusMutation()
  const [changeTodosColor] = useChangeTodosColorMutation()
  const [renameTaskTodoTitle] = useRenameTaskTodoTitleMutation()
  const [colors, setColors] = useState([])
  const [allTaskStatus] = useAllTaskStatusMutation()
  const [deleteTaskTodo] = useDeleteTaskTodoMutation()
  useEffect(() => {
    if (filter === 'incomplete') {
      setToggle({ ...toggle, completed: false })
    } else if (filter === 'complete') {
      setToggle({ ...toggle, completed: true })
    } else if (filter === 'all') {
      setToggle({ ...toggle, completed: '' })
    } else {
      setToggle({ ...toggle, completed: '' })
    }
    if (filter === 'all-completed') {
      data?.todos?.length > 0 &&
        data?.todos?.filter((item) => item?.completed === false)?.length > 0 &&
        data?.todos?.filter((item) => {
          if (item?.completed === false) {
            allTaskStatus({ todo: { ...item } })
          }
          return {}
        })
    }
    if (filter === 'clear-complete') {
      data?.todos?.length > 0 &&
        data?.todos?.filter((item) => item?.completed === true)?.length > 0 &&
        data?.todos?.filter((item) => {
          if (item?.completed === true) {
            deleteTaskTodo(item?.id)
          }
          return {}
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter])
  const handleColorChange = (value) => {
    if (!colors.includes(value)) {
      setColors([...colors, value])
    } else {
      const color = colors?.length > 0 && colors.filter((item) => item !== value)
      setColors(color)
    }
  }
  useMemo(() => {
    if (colors?.length) {
      setToggle({ completed: toggle.completed || '', colors: colors || [] })
    }
  }, [colors, setToggle, toggle.completed])
  return (
    <>
      <div className="flex items-center justify-between">
        <p>{totalTask?.length || 0} tasks left</p>
        <div>
          <ul className="flex space-x-1 items-center text-xs">
            <li
              className={`cursor-pointer ${filter === 'all' && 'font-bold'}`}
              onClick={() => setFilter('all')}
            >
              All
            </li>
            <li>|</li>
            <li
              className={`cursor-pointer ${filter === 'incomplete' && 'font-bold'}`}
              onClick={() => setFilter('incomplete')}
            >
              Incomplete
            </li>
            <li>|</li>
            <li
              className={`cursor-pointer ${filter === 'complete' && 'font-bold'}`}
              onClick={() => setFilter('complete')}
            >
              Complete
            </li>
            <li></li>
            <li></li>
            <li
              className={`h-3 w-3 border-2 border-green-500 md:hover:bg-green-500 rounded-full cursor-pointer ${
                data?.colors?.length && data?.colors?.includes('green') ? 'bg-green-500' : ''
              }`}
              onClick={() => handleColorChange('green')}
            ></li>
            <li
              className={`h-3 w-3 border-2 border-green-500 md:hover:bg-red-500 rounded-full cursor-pointer ${
                data?.colors?.length && data?.colors?.includes('red') ? 'bg-red-500' : ''
              }`}
              onClick={() => handleColorChange('red')}
            ></li>
            <li
              className={`h-3 w-3 border-2 border-green-500 md:hover:bg-yellow-500 rounded-full cursor-pointer ${
                data?.colors?.length && data?.colors?.includes('yellow') ? 'bg-yellow-500' : ''
              }`}
              onClick={() => handleColorChange('yellow')}
            ></li>
          </ul>
        </div>
      </div>

      <br />
      <h2 className="text-[16px] mb-3 border-b pb-2 text-black">Incomplete Task Lists</h2>
      <div className="mt-2 text-gray-700 text-sm max-h-[150px] overflow-y-auto">
        {isSuccess &&
          data?.todos?.length > 0 &&
          data?.todos?.filter((item) => item?.completed === false)?.length > 0 &&
          data?.todos
            .filter((item) => item?.completed === false)
            .map((todo, i) => (
              <Todo
                key={i}
                todo={todo}
                changeTodosStatus={changeTodosStatus}
                isLoading={isLoading}
                changeTodosColor={changeTodosColor}
                handleDeleteTodo={deleteTaskTodo}
                renameTaskTodoTitle={renameTaskTodoTitle}
              />
            ))}
      </div>
      <h2 className="text-[16px] mb-3 border-b pb-2 text-black">Complete Task Lists</h2>
      <div className="mt-2 text-gray-700 text-sm max-h-[150px] overflow-y-auto">
        {isSuccess &&
          data?.todos?.length > 0 &&
          data?.todos?.filter((item) => item?.completed === true)?.length > 0 &&
          data?.todos
            .filter((item) => item?.completed === true)
            .map((todo, i) => (
              <Todo
                key={i}
                todo={todo}
                changeTodosStatus={changeTodosStatus}
                isLoading={isLoading}
                changeTodosColor={changeTodosColor}
                handleDeleteTodo={deleteTaskTodo}
                renameTaskTodoTitle={renameTaskTodoTitle}
              />
            ))}
      </div>
    </>
  )
}
